import { Skeleton } from '@/components/ui/skeleton'

const CardSkeleton = () => {
    return (
        <div className="flex flex-row gap-2  border rounded-lg p-2 pt-2 bg-gray-800">
            <div className="flex flex-col w-full gap-4"> 
                <Skeleton className="h-[38px] w-[460px] bg-gray-300" />
                <div className='flex gap-2'> 
                    <div 
                        className="flex border rounded-lg p-2"
                    >
                        <div className="flex gap-2">
                            <div className="flex items-center justify-center">
                             <Skeleton className="h-[38px] w-[143px] bg-gray-300" />
                            </div> 
                            <div className="flex items-center justify-center">
                            <Skeleton className="h-[38px] w-[143px] bg-gray-300" />
                            </div> 
                            <div className="flex items-center justify-center">
                            <Skeleton className="h-[38px] w-[143px] bg-gray-300" />
                            </div>
                        </div>
                    </div> 
                </div>
            </div>  
        </div> 
    )
}

export default CardSkeleton
